import {RouteContext} from "../../RouteContext";
import { Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import Post from "./Post";
import Edit from "./Edit";
import KeywordRouter from "./keyword/KeywordRouter";
import PolicyRouter from "./policies/PolicyRouter";
import ParticipationRouter from "./participation/ParticipationRouter";
import PathRouter from "./paths/PathRouter";
import FileRouter from "./files/FileRouter";
import BrowserRouter from "./browsers/BrowserRouter";
import JointRouter from "./joints/JointRouter";
import EventRouter from "./events/EventRouter";
import ReportRouter from "./reports/ReportRouter";
import ReasonRouter from "./reportReasons/ReasonRouter";
import FunnelRouter from "./funnel/FunnelRouter";


export default function PlaceRouter(props: RouteContext) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:id'} element={<Detail {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/edit/:id'} element={<Edit {...props} />} />
            <Route
                path={'/keywords/*'}
                element={<KeywordRouter {...props} />} />
            <Route
                path={'/participations/*'}
                element={<ParticipationRouter {...props} />} />
            <Route
                path={'/participations/policies/*'}
                element={<PolicyRouter {...props} />} />
            <Route path={'/paths/*'}
                   element={<PathRouter {...props}/>} />
            <Route
                path={'/paths/files/*'}
                element={<FileRouter {...props} />} />
            <Route
                path={'/paths/browsers/*'}
                element={<BrowserRouter {...props} />} />
            <Route
                path={'paths/browsers/*'}
                element={<BrowserRouter {...props} />} />
            <Route
                path={'/paths/joints/*'}
                element={<JointRouter {...props} />} />
            <Route
                path={'/paths/joints/events/*'}
                element={<EventRouter {...props} />} />
            <Route
                path={'/paths/joints/reports/*'}
                element={<ReportRouter {...props} />} />
            <Route
                path={'/paths/joints/reports/reasons/*'}
                element={<ReasonRouter {...props} />} />
            <Route
                path={'/funnels/stats/*'}
                element={<FunnelRouter {...props} />} />
        </Routes>
    </>
}